import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraTabs } from "../../../components/AtiraTabs";
import { Modal } from "../../../components/modal/Modal";
import { UserRoles } from "../../../model/user/types/UserRoles";
import { useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { EntriesExportTab } from "./EntriesExportTab";
import { EntriesImportTab } from "./EntriesImportTab";
import { useDrawersContext } from "../../tasks/drawers-context";

const StyledTabs = styled(AtiraTabs)`
  padding-inline: 0;
  width: 100%;

  .ant-tabs-nav-wrap {
    justify-content: center !important;
  }

  .ant-tabs-nav-list {
    width: 100%;
  }

  .ant-tabs-tab {
    flex-grow: 1;
    justify-content: center;
  }

  .ant-tabs-nav::before {
    display: none !important;
  }
`;

export const ExportImportEntriesModal: React.FC = () => {
  const { importExportVisible, setImportExportVisible } = useDrawersContext();
  const { t } = useTranslation();

  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;
  const { roles } = user;

  const items = [
    { key: "1", label: t("common.import"), children: <EntriesImportTab /> },
    { key: "2", label: t("common.export"), children: <EntriesExportTab /> },
  ];

  const canImportExport = !roles.includes(UserRoles.MEMBER);

  if (!canImportExport) {
    return null;
  }

  return (
    <Modal
      open={importExportVisible}
      onClose={() => setImportExportVisible(false)}
      title={t("entries.exim.modal.title")}
    >
      <StyledTabs items={items} />
    </Modal>
  );
};
